import React, { useState, useRef, useEffect, forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import { Spin, Button, Icon, Col, Row } from 'antd';
import playerjs from 'player.js';

const receiver = new playerjs.Receiver();

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, language } = props,
    { required, questions, defaultValue, id, mediaFiles } = inputData,
    { getFieldDecorator } = form;
  const [disableControls, setDisableControls] = useState(false)
  const [loading, setLoading] = useState(false)
  const audioRef = useRef()

  const playAudioOneTime = () => {
    setLoading(true);
    if (audioRef.current) {
      audioRef.current.play();
      setDisableControls(true);
    }
  }

  useEffect(() => {
    let isMounted = true;

    if ('current' in audioRef) {
      // methods
      receiver.on('play', () => {
        audioRef.current.play();
        // receiver.emit('play');
      });
      receiver.on('pause', () => {
        audioRef.current.pause();
        // receiver.emit('pause');
      });
      receiver.on('getPaused', (callback) => {
        callback(audioRef.current.paused);
      });
      receiver.on('getCurrentTime', (callback) => {
        callback(audioRef.current.currentTime);
      });
      receiver.on('setCurrentTime', (currentTime) => {
        audioRef.current.currentTime = currentTime;
      });
      receiver.on('getDuration', (callback) => {
        callback(audioRef.current.duration);
      });
      receiver.on('getVolume', (callback) => {
        callback(audioRef.current.volume * 100);
      });
      receiver.on('setCurrentTime', (currentTime) => {
        audioRef.current.currentTime = currentTime;
      });

      //events
      audioRef.current.addEventListener('playing', () => {
        if (isMounted) setLoading(false);
        receiver.emit('play');
      });
      audioRef.current.addEventListener('paused', () => {
        receiver.emit('pause');
      });
      audioRef.current.addEventListener('ended', () => {
        receiver.emit('ended');
      });
      audioRef.current.addEventListener('timeupdate', () => {
        receiver.emit('timeupdate', {
          seconds: audioRef.current.currentTime,
          duration: audioRef.current.duration
        });
      });
      audioRef.current.addEventListener('progress', () => {
        receiver.emit('buffered', {
          percent: audioRef.current.buffered.length
        });
      });
      audioRef.current.addEventListener('canplay', (event) => {
        receiver.ready();
      });
    } else {
      if (isMounted) setLoading(false);
    }

    return () => { isMounted = false }
  }, [])

  return (
    <FormItem>
      {getFieldDecorator(id, {
        initialValue: defaultValue,
        rules: [
          {
            required,
            message: "Required Field"
          }
        ]
      })(
        <Row type="flex" justify="center" align="middle">
          <Col>
            {
              loading ?
              <Spin /> :
              <Button onClick={playAudioOneTime} disabled={disableControls}
                      type="primary" icon="caret-right" shape="circle"
                      size={"large"}
              />
            }
            <audio
              ref={audioRef}
              src={mediaFiles[0].src}
            >
              Your browser does not support the
              <code>audio</code> element.
            </audio>
          </Col>
        </Row>
      )}
    </FormItem>
  );
});
